import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { CodePayload } from 'Interfaces/Profile';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((values: CodePayload) =>
    $actions.user.signInGoogleAuthenticator(dispatch, values),
  );
};
